module.exports = __webpack_public_path__ + "img/16x9_center.9bb7b18e.jpg";